// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { StorageAlertContainer } from 'admin/computeResource/common/StorageAlert/Styles';
import { ReactComponent as RoundedExclamation } from 'common/icons/rounded-exclamation.svg';
import { COLORS } from 'common/theme';
import { Translate } from '@plesk/ui-library';
import { Tooltip } from 'common/components/Tooltip/Tooltip';
import { IComputeResourceResponse } from 'common/api/resources/ComputeResource';
import { pathTo } from 'common/helpers/core';
import { Link } from 'react-router-dom';
import { useIsDown } from 'common/hooks/useBreakpoint';
import { BREAKPOINTS } from 'common/styles/breakpoints';

interface IProps {
    computeResource: IComputeResourceResponse;
}

export const StorageAlert: React.FC<IProps> = ({ computeResource }) => {
    const isCompact = useIsDown(BREAKPOINTS.LG);

    if (!computeResource.has_unknown_status_storages &&
        !computeResource.has_unhealthy_storages) {
        return null;
    }

    const to = pathTo(`compute_resources/${computeResource.id}#storages`);

    const renderAlert = (iconColor: string, content: string) => {
        const label = <Translate content={content} />;

        return (
            <StorageAlertContainer iconColor={iconColor}>
                <Tooltip shown={isCompact} title={label}>
                    <Link to={to}>
                        <RoundedExclamation />

                        <span>{label}</span>
                    </Link>
                </Tooltip>
            </StorageAlertContainer>
        );
    };

    return (
        <>
            {computeResource.has_unhealthy_storages &&
                renderAlert(COLORS.RED_0, 'computeResource.hasUnhealthyStorages')}

            {computeResource.has_unknown_status_storages &&
                renderAlert(COLORS.GREY_70, 'computeResource.hasUnknownStatusStorages')}
        </>
    );
};
